import { createPostEndpoint } from '@sonar-software/sonar-http';

export type PostSetupAuditTrailViewRequest = {
	name: string;
	filter?: string;
	ordering?: string;
	advanceFilter?: string;
};

export type PostSetupAuditTrailViewResponse = {
	viewId: number;
};

export const postSetupAuditTrailViews = createPostEndpoint<
	PostSetupAuditTrailViewRequest,
	PostSetupAuditTrailViewResponse
>('/api/v3/setup-audit-trail/views');
